import './styles.css';

export default function Container({ children }) {
    return (
        <div className="aira-container mx-auto">
            {children}
        </div>
    )
}